import React from "react";
import { Loadable, IRouteItem } from "@techzyapp/ui-lib";
import { AUDIT_LOG_DETAILS_PATH, AUDIT_LOGS_PATH } from "utils/constants/paths";

const AuditLogs = Loadable(React.lazy(() => import("./View")));
const AuditLogDetail = Loadable(React.lazy(() => import("./View/Detail")));

export const AuditLogsRoute: IRouteItem = {
  path: AUDIT_LOGS_PATH,
  iconName: "Hierarchy3",
  element: React.createElement(AuditLogs),
  name: "Audit Logs",
  children: [
    {
      path: `${AUDIT_LOG_DETAILS_PATH}/:id`,
      element: React.createElement(AuditLogDetail),
      showInDrawer: false,
    },
  ],
};
